"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InflectionSuggesterCreator = void 0;
const shal_inflection_suggester_1 = require("./shal-inflection-suggester");
const stable_inflection_suggester_1 = require("./stable-inflection-suggester");
__exportStar(require("./revision-suggester"), exports);
__exportStar(require("./shal-inflection-suggester"), exports);
__exportStar(require("./stable-inflection-suggester"), exports);
__exportStar(require("./suggester"), exports);
class InflectionSuggesterCreator {
    static createByVersion(version, text, ignoreOptions) {
        var _a;
        const match = version.match(/^(\w+)(?:\.(\w+))?$/);
        if (match !== null) {
            const generation = (_a = match[1]) !== null && _a !== void 0 ? _a : "";
            const subgeneration = match[2] !== undefined ? parseInt(match[2], 10) : 0;
            if (generation === "6" || (generation === "7" && subgeneration <= 1) || generation === "S") {
                return new stable_inflection_suggester_1.StableInflectionSuggester(text, ignoreOptions);
            }
            else if (generation === "7" && subgeneration >= 2) {
                return new shal_inflection_suggester_1.ShalInflectionSuggester(text, ignoreOptions);
            }
            else {
                return undefined;
            }
        }
        else {
            return undefined;
        }
    }
}
exports.InflectionSuggesterCreator = InflectionSuggesterCreator;
